export const path = (p: any, o: any) => {
    const reducerFunction = (xs: any, x: any) => {
        return xs && xs[x] ? xs[x] : null
    }
    return p.reduce(reducerFunction, o)
}
